<template>
  <div class="kl-faq__container container" :style="{ minHeight: '80vh' }">
    <div class="row">
      <div class="col-xs-12">
        <section class="kl-faq-list">
          <KeepAlive>
            <component :is="translateComponent" />
          </KeepAlive>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PomocTlumaczenia",
  data() {
    return {
      lang: null,
      platform: null,
    };
  },
  computed: {
    translateComponent() {
      if (!this.lang || !this.platform) return null;
      const variant = `${this.platform}-${this.lang}`;
      switch (variant) {
        case "android-pl":
          return () =>
            import("../../components/translate/android/TranslateAndroidPl.vue");
        case "android-en":
          return () =>
            import("../../components/translate/android/TranslateAndroidEn.vue");
        case "android-uk":
          return () =>
            import("../../components/translate/android/TranslateAndroidUk.vue");
        case "android-ru":
          return () =>
            import("../../components/translate/android/TranslateAndroidRu.vue");
        case "ios-pl":
          return () =>
            import("../../components/translate/ios/TranslateIosPl.vue");
        case "ios-en":
          return () =>
            import("../../components/translate/ios/TranslateIosEn.vue");
        case "ios-uk":
          return () =>
            import("../../components/translate/ios/TranslateIosUk.vue");
        case "ios-ru":
          return () =>
            import("../../components/translate/ios/TranslateIosRu.vue");
        case "widget-pl":
          return () =>
            import("../../components/translate/widget/TranslateWidgetPl.vue");
        case "widget-en":
          return () =>
            import("../../components/translate/widget/TranslateWidgetEn.vue");
        case "widget-uk":
          return () =>
            import("../../components/translate/widget/TranslateWidgetUk.vue");
        case "widget-ru":
          return () =>
            import("../../components/translate/widget/TranslateWidgetRu.vue");
        default:
          return null;
      }
    },
  },
  created() {
    this.$emit("showFaqHeader", false);
    this.checkLanguage();
    this.checkPlatform();
  },
  methods: {
    checkLanguage() {
      const { lang } = this.$route.params;
      if (["pl", "en", "uk", "ru"].includes(lang)) {
        this.lang = lang;
        return;
      }
      this.$router.replace({ name: "KontoLibrus" });
    },
    checkPlatform() {
      const { platform } = this.$route.params;
      if (["android", "ios", "widget"].includes(platform)) {
        this.platform = platform;
        return;
      }
      this.$router.replace({ name: "KontoLibrus" });
    },
  },
};
</script>
